---
en:
  api_key: API key
  api_keys: API Keys
  api_keys_company_access_limit: Showing the first %{count} companies. Use search to find others.
  api_keys_confirm_rotate: Rotating the token will invalidate the existing key. Continue?
  api_keys_toast:
    copied: Token copied to clipboard
    create_failed: Could not create API key
    created: API key created
    delete_failed: Could not delete API key
    deleted: API key deleted
    export_started: Export started - we will email you when it is ready
    rotate_failed: Could not rotate API key token
    rotated: API key token rotated
    update_failed: Could not update API key
    updated: API key updated
  api_keys_token_too_short: Token must be at least {count} characters long
  company_access_hint: Select the companies which the API user should have access to
  current_access: Current Access
  expensive_req: most expensive requests last 7 days
  recent_request: most recent requests
